import styled from "styled-components";

export const Loader = styled.div`
width: 100%;
height: calc(100vh - 120px);
display: flex;
align-items: center;
justify-content: center;
`;

export const RootContainer = styled.div`
  padding: 24px 0;
`;

export const Top = styled.div`
display: flex;
align-items: center;
justify-content: center;
`;

export const Image = styled.img.attrs({
  alt: 'icon',
})`
  width: 64px;
  height: 64px;
  aspect-ratio: 1;
  object-fit: cover;
  border-radius: 8px;
`;

export const Title = styled.div`
  padding-top: 24px;
  padding-bottom: 16px;
  text-align: center;
  color: #F9F9F9;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const PlayerListContainer = styled.div`
  width: 100%;
  margin: 0 0 0 0;
  overflow: auto;
`;

export const PlayerBox = styled.div`
  background: transparent;
  padding: 16px;
  display: flex;
  flex-direction: row;
  gap: 12px;
  border-top: ${props => props.first === 'true' ? '1px solid #212224' : 'none'};
  border-bottom: 1px solid #212224;
`;

export const Number = styled.p`
padding-left: 20px;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 200;
  line-height: normal;
  color: #F9F9F9;
`;

export const DataContainer = styled.div`
  flex-grow: 1;
  gap: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const NameAndAmountContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
`

export const PlayerName = styled.p`
  flex-grow: 1;
  color: #F9F9F9;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`

export const Amount = styled.p`
  color: #F9F9F9;
  text-align: right;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`

export const PhoneNumberContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
`

export const PhoneNumber = styled.p`
  flex-grow: 1;
  color:  #808080;
  font-size: 12px;
  font-style: normal;
  font-weight: 200;
  line-height: normal;
`
